var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoorahPods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_13027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 14.25V9.56252C0.75 7.23752 1.6125 4.98752 3.15 3.33752C4.6875 1.68752 6.825 0.750015 9 0.750015C11.175 0.750015 13.275 1.68752 14.85 3.33752C16.425 4.98752 17.25 7.23752 17.25 9.56252V14.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 10.5H0.75V15.75C0.75 16.575 1.425 17.25 2.25 17.25H4.875V10.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.5H17.25V15.75C17.25 16.575 16.575 17.25 15.75 17.25H13.125V10.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_13027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoorahPods);
export default __webpack_public_path__ + "static/media/shoorahPods.1b33d9e42c3fdaa5a686486a06ff30af.svg";
export { ForwardRef as ReactComponent };